export const home_cn = {
  viewmore: '查看更多',
  banner: {
    title: '您心动了吗？',
    desc: '立即注册探索JCtrans更多精品服务',
    reigister: '注册',
    joinUs: '加入会员',
    mb: '加入会员 您将获得',
    desc1: '会议门票专属折扣和专属身份',
    desc2: '全球货代联系方式',
    desc3: '风险保障等权益',
    desc4: '应盘权限',
    desc5: '全球货代联系方式',
    desc6: '风险保障等权益',
  },
  notlogin: {
    benefit: {
      title1: '商机链接',
      title2: '合作保障',
      title3: '营销推广',
      title4: '经营提效',
      desc1:
        '汇聚全球1.2万+付费会员，77万+注册用户，覆盖181个国家，全年350万+次商机撮合量',
      desc2: '严格准入门槛，建立有信誉的圈子，平台提供最高15万美元合作风险保障',
      desc3: '官方邮件和社媒推广，推广您的商铺和品牌，每年举办多场全球大型会议',
      desc4: '免手续费的支付服务，享受全球会议折扣、保险、及物流工具优惠价',
    },
    airline: {
      title: '探索为您企业定制的海量商机',
      desc: '近三十天全平台发布询盘',
      desc1: '热门航线',
      desc2: '业务范围',
      desc3: '货物类别',
      card1: '普货',
      card2: '项目货',
      card3: '危险品',
      card4: '跨境电商',
      card5: '冷藏',
      inquiries: '月均询盘',
      vacancy: '报价余位',
      over: '超过',
      less: '不足',
      sea: '海运',
      air: '空运',
      land: '陆运',
      rail: '铁路',
      inter: '多式联运',
      decla: '清关&报关&FBA...',
    },
    business: {
      title: '发现新的合作机会',
      subtitle1: '搜索全球优质代理',
      subtitle2: '多种业务类型会员',
      subtitle3: '保障合作无忧',
      subtitle4: '数字化商铺',
      subdesc1: '丰富的全球会员资源覆盖181个国家1.2万+付费会员，77万+注册用户',
      subdesc2:
        '从危险品到大型项目，丰富的会员和精准的搜索筛选助你快速找到专业合作伙伴',
      subdesc3:
        '严格的入会审查机制，打造诚信合作圈子，提供最高15万美金的合作风险保障',
      subdesc4: '丰富的标签、证书、视频展示业务能力，在线IM接待实时与客户沟通',
    },
    protection: {
      mainTitle: '金融保障服务',
      mainDesc: `会员合作可享受高达15万美元的合作风险保障服务。避免在背景或信用检查上浪费时间和费用。`,
      titled5: '最高',
      titled3: '15',
      titled4: '万美金合作风险保障',
      title: '最高',
      titled1: '15',
      titled2: '万美金合作风险保障',
      title1: '高额保障',
      desc1:
        '每位会员每年享受最高15万美金合作风险保障，保障会员安心合作，有效节省在信用调查上浪费时间和费用。',
      title2: '风险防范',
      desc2:
        '平台具备完善的审查机制、风控大数据后台以及黑名单预警，帮助会员每年避免潜在风险量5200起',
      title3: '高效，专业纠纷服务',
      desc3:
        '24小时之内应答，快速受理，高效专业。纠纷专家，一对一提供服务。86%案件在30个工作日内处理完成。',
      title4: '会员合作风险保障',
      desc4:
        '符合平台规则的坏账，在审核通过后将会第一时间得到补偿。每年帮助会员追回纠纷案件的金额 1.5亿人民币',
    },
    promotion: {
      title: '多渠道企业品牌营销，优质推广精准触达',
      title1: '邮件推广',
      desc1: '发往全球30,000+优质的货代企业，覆盖181个国家和867个城市',
      title2: '社媒推广',
      desc2: '多渠道覆盖，每日3万次曝光，高效助力企业品牌精准营销',
    },
    jcpay: {
      baseTitle1: '一年',
      baseTitle2: '节省上万元支付手续费',
      baseTitle3: '的结算工具',
      title: '一年节省上万元支付手续费的结算工具',
      titled1: '一年',
      titled2: '节省上万元',
      titled3: '支付手续费的结算工具',
      title1: '会员一站式免费使用',
      title2: '0手续费，实时到账',
      title3: '安全可靠',
      desc1: 'JCtrans会员账号已免费升级权益，可直接登录进行交易',
      desc2: '会员间收付款没有任何手续费且实时到账',
      desc3: '稳定的银行合作关系，保证账户资金安全',
    },
    costs: {
      title: '降本增效，有我无忧',
      title1: '货运险',
      title2: '船期',
      title3: '全链路跟踪',
      title4: 'FMC资质服务',

      desc1: '费率低：普货一切险0.02%起，最低保费15元',
      desc2: '效率高：在线投保，秒出单',
      desc3: '服务好：1对1专属客服，保姆式服务',
      desc4:
        '险种全：进出口/内贸；海陆空多式联运；普货/易碎品/危险品/冷藏品/特殊货等',

      desc5: '覆盖40+主流航司',
      desc6: '全球主流航线船期、想查就查',
      desc7: '动态数据实时更新',

      desc8: '覆盖50+船司 1800+港口',
      desc9: '全程可视',
      desc10: '关键节点信息一手掌握',

      desc11: '提升美线竞争力',
      desc12: '船司直订、自主签发提单',
      desc13: '长期合作的保障',
    },
    meeting: {
      baseTitle: '物流行业最具影响力的高端会议之一',
      title: '物流行业最具影响力的高端会议之一',
      title1: '高效商机洽谈',
      title2: '品牌形象塑造',
      title3: '触达全球资源',
      desc1: '10万+轮面对面洽谈，精准匹配商机',
      desc2: '年5,000+家企业多维度曝光，助力企业发展',
      desc3: '140+家国家及地区，全球货代、触手可达',
    },
  },
  login: {
    tabs: {
      inquiry: '询盘',
      company: '公司名录',
      event: '全球会议',
      title1: '高效洽谈',
      title2: '扩展人脉',
      title3: '会议动态',
      desc1: '促进合作',
      desc2: '拓展全球商机',
      desc3: '品牌塑造',
      desc4: '助力企业发展',
      desc5: '分享实践',
      desc6: '把握行业脉搏',
      jcPay: '金融服务',
    },
    meetings: {
      conference: '交洽会',
      view_video: '查看视频',
      video_title: '精彩瞬间',
      exhibition: '博览会',
      industry: '行业活动',
      previous: '往届参会公司',
      registration: '报名参会',
    },
    company: {
      memeber_title: '全球会员分布',
      proxy: '系统推荐代理',
      our_member: '我们的会员',
      become_mem: '加入会员',
      become_desc:
        '目前该国家还没有会员，现在加入您将成为第一个会员，商机您将独享~',
      cooperative: '合作保障',
      cooper_desc: '助力客户之间找到更高质量且长期稳定的合作伙伴',
      post_inquiry: '发布询盘',
    },
    map: {
      title: '我们的全球影响力',
      warn: '按住 Control 并滚动鼠标滚轮才可缩放地图',
    },
  },
}

export const home_en = {
  viewmore: 'View more',
  banner: {
    title: 'Ready to get started?',
    desc: 'Explore more services by signing up today!',
    reigister: 'Register',
    joinUs: 'Become a Member',
    mb: 'Member Benefits',
    desc1: 'Conference ticket discounts',
    desc2: 'Global forwarders contact information',
    desc3: 'Cooperation Risk Protection,etc.',
    desc4: 'Access to inquiry system',
    desc5: 'Global forwarders contact information',
    desc6: 'Cooperation Risk Protection,etc ',
  },
  notlogin: {
    benefit: {
      title1: 'Business Opportunity Matching',
      title2: 'Cooperation Risk Protection',
      title3: 'Marketing and Promotion Services',
      title4: 'Reduce Costs and Boost Efficiency',
      desc1:
        'We connect with over 12,000 high-quality freight forwarders worldwide, more than 770,000 registered users, covering 181 countries, with over 3,500,000 business opportunities each month.',
      desc2:
        'With strict entry requirements, build a reputable group and offer up to $150,000 USD in cooperation risk protection annually.',
      desc3:
        'We promote your store and brand through JCtrans official email channal. We host multiple global conference annually.',
      desc4:
        'We offer payment tools with no handling fee and discounts on global conferences, insurance, and tools.',
    },
    airline: {
      title: 'Explore millions of opportunities customized for your business',
      desc: 'Inquiries have been posted in the past 30 days',
      desc1: 'Popular Routes',
      desc2: 'Freight Type',
      desc3: 'Cargo Type',
      card1: 'General',
      card2: 'Projects',
      card3: 'Dangerous Goods',
      card4: 'eCommerce',
      card5: 'Reefer Container ',
      inquiries: 'Monthly Inquiries',
      vacancy: 'Quotation Vacancy',
      over: 'Over',
      less: 'Less Than',
      sea: 'Sea',
      air: 'Air',
      land: 'Land',
      inter: 'Intermodal',
      rail: 'Rail',
      decla: 'Declaration & Clearance & FBA ...',
    },
    business: {
      title: 'Discover new business opportunity',
      subtitle1: "Search the world's best agency",
      subtitle2: 'We offer specialized members to meet diverse needs',
      subtitle3: 'Guarantee cooperation without worry',
      subtitle4: 'Digital store',
      subdesc1:
        'Our extensive global membership spans 181 countries, with over 12,000 members, more than 770,000 registered users.',
      subdesc2:
        'From dangerous goods to large-scale projects, our extensive member base and precise search system will match you with professional partners.',
      subdesc3:
        'Strict entry review process to create an credible platform and provide up to $150,000 cooperation risk protection.',
      subdesc4:
        'Rich business advantages labels, certificates, videos to fully demonstrate the ability of members. Instant messaging system to reach customers.',
    },
    protection: {
      mainTitle: 'Cooperation Risk Protection',
      mainDesc: `Cooperation between members can enjoy up to $150,000 financial
          protection service. Avoid wasted time and expense on background or
          credit checks`,
      titled5: 'Up to ',
      titled3: '$150,000 ',
      titled4: 'cooperation risk protection',
      title1: 'Sufficient cooperation risk protection',
      desc1:
        "Each member enjoys up to $150,000 protection per year, which protects members' cooperative rights and effectively save costs wasted on credit checks.",
      title2: 'Risk prevention',
      desc2:
        'The JCtrans has a complete review process, data background for risk control and blacklist warning to help members stay away from risks.',
      title3: 'Professional dispute services',
      desc3:
        'Answer within 24 hours, fast acceptance, efficient and professional. Dispute specialist, 1-on-1 service.',
      title4: 'Cooperation risk protection',
      desc4:
        'Bad debts in compliance with JCtrans cooperation risk protection rules will be paid in the first time.',
    },
    promotion: {
      title:
        'Multi-channel corporate promotion, accurate access to global business opportunities',
      title1: 'Email Marketing Promotion',
      desc1:
        'Deliver to 30000+ freight forwarders worldwide. Covering 181 countries and regions and 867 cities.',
      title2: 'Social Media Promotion',
      desc2:
        'Multi-channel with 30,000 exposures per day, efficiently assisting in accurate marketing of company branding.',
    },
    jcpay: {
      baseTitle1: 'Official Settlement Tool to Save ',
      baseTitle2: 'Tens of Thousands of Dollars',
      baseTitle3: ' of Bank Fees Per Year',
      title:
        'Official settlement tool to save tens of thousands of dollars of bank fees per year',
      titled1: 'Settlement tool that ',
      titled2: 'saves $10,000 ',
      titled3: 'a year in transaction fees',
      title1: 'Pay JCtrans members on one platform',
      title2: '0 fees, receive payment in real-time',
      title3: 'Safe and reliable',
      desc1:
        'Your JCtrans member account has activated JC Pay services. Please log in for transactions',
      desc2:
        'Receive and make payment in real-time without any transaction fees',
      desc3: 'Stable banking cooperation to ensure the safety of funds.',
    },
    costs: {
      title: 'Lower costs, Higher efficiency',
      title1: '货运险',
      title2: '船期',
      title3: '全链路跟踪',
      title4: 'FMC资质服务',

      desc1: '费率低：普货一切险0.02%起，最低保费15元',
      desc2: '效率高：在线投保，秒出单',
      desc3: '服务好：1对1专属客服，保姆式服务',
      desc4:
        '险种全：进出口/内贸；海陆空多式联运；普货/易碎品/危险品/冷藏品/特殊货等',

      desc5: 'Cover more than 40 shippingline',
      desc6: 'Global main shipping routes, search whenever you want',
      desc7: 'Real-Time Updates',

      desc8: 'Cover more than 50 shippingline and 1800 ports',
      desc9: 'End-to-End Visibility',
      desc10: 'Key Milestones Always in Sight',

      desc11: 'Easier to Conduct U.S. Route Business',
      desc12: 'Ability to Issue Bills of Lading',
      desc13: 'Long-term Partnership Assurance',
    },
    meeting: {
      baseTitle:
        'One of the Most Influential High-End Conferences in the Logistics Industry',
      title:
        'The most influential high-end conferences in the logistics industry',
      title1: 'Meetings',
      title2: 'Branding',
      title3: 'Resources',
      desc11: '100,000+ rounds 1-1 meetings',
      desc1: 'Rounds\n1-1 Meetings',
      desc22: '5,000+ enterprises marketing',
      desc2: 'Enterprises\n Marketing',
      desc33: "140+ countries' agents",
      desc3: `Countries'\n Agents`,
    },
  },
  login: {
    tabs: {
      inquiry: 'Inquiry',
      company: 'Company Directory',
      event: 'Event',
      title1: 'Efficient negotiation',
      title2: 'Expand contacts',
      title3: 'Conference news',
      desc1: 'Promote cooperation',
      desc2: 'Expand global business opportunities',
      desc3: 'Brand building',
      desc4: 'Help the development of enterprises',
      desc5: 'Share practice',
      desc6: 'Grasp the pulse of the industry',
      jcPay: 'JC Pay',
    },
    meetings: {
      conference: 'Global Conference',
      view_video: 'View Video',
      video_title: 'Moments of Conference',
      exhibition: 'Exhibition',
      industry: 'Industry Event',
      previous: 'Previous Conference Atteendees',
      registration: 'Registration',
    },
    company: {
      memeber_title: 'Global Membership Distribution',
      proxy: 'System recommended agent',
      our_member: 'Our Members',
      become_mem: 'Become a member',
      become_desc:
        'There are currently no members in this country. Join now and you will become the first member, and you will have exclusive business opportunities~',
      cooperative: 'Cooperative guarantee',
      cooper_desc:
        'Assisting customers looking for high-quality and long-term stable partners.',
      post_inquiry: 'Post Inquiry',
    },
    map: {
      title: 'Our Global Reach',
      warn: 'Press Control and scroll the mouse wheel to zoom the map',
    },
  },
}
